<h4 class="mb-3">Predicted footfall for the week</h4>
<div class="height-300px">
  <canvas baseChart
          [datasets]="chartData"
          [labels]="chartLabels"
          [type]="'bar'"
          [options]="chartOptions"
  ></canvas>
</div>
